export interface UtmProps {
  source: string;
  click_id: string;
  web_id: string;
  addons: string;
  contact_id?: string;
}

type UtmKeysMap = Record<string, Omit<UtmProps, 'source'>>;

export const UTM_SOURCE = 'utm_source';

export const utmKeysMap: UtmKeysMap = {
  leadgid: {
    click_id: 'cpa_click_id',
    web_id: 'cpa_wm_id',
    addons: '',
  },
  'sravni.ru': {
    click_id: 'cpa_click_id',
    web_id: 'cpa_wm_id',
    addons: '',
  },
  finpublic_cpa: {
    click_id: 'click_id',
    web_id: 'utm_medium',
    addons: '',
  },
  upsala: {
    click_id: 'clickid',
    web_id: 'wmid',
    addons: 'gclid',
  },
  doaff: {
    click_id: 'v',
    web_id: 'web_id',
    addons: '',
  },
  leadssu: {
    click_id: 'transaction_id',
    web_id: 'affiliate_id',
    addons: '',
  },
  'pdl-profit': {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: '',
  },
  crezu: {
    click_id: 'click_id',
    web_id: 'click_id',
    addons: '',
  },
  sales_doubler: {
    click_id: 'aff_sub',
    web_id: 'aff_id',
    addons: '',
  },
  loangate: {
    click_id: 'afclick',
    web_id: '',
    addons: `contactID`,
  },
  cpamarket: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: '',
  },
  finline: {
    click_id: '',
    web_id: 'partner_id',
    addons: `contactID`,
  },
  '3snet_apileads': {
    click_id: '',
    web_id: '',
    addons: `contactID`,
  },
  guruleads: {
    click_id: 'clickid',
    web_id: 'wm_id',
    addons: '',
  },
  'cpa.i-credit.kz': {
    click_id: 'utm_content',
    web_id: 'utm_content',
    addons: '',
  },
  c2m: {
    click_id: 'cpa_click_id',
    web_id: 'wmid',
    addons: '',
  },
  ecpc100: {
    click_id: 'cpa_click_id',
    web_id: 'cpa_wm_id',
    addons: '',
  },
  credy: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: '',
  },
  goodaff: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: '',
  },
  upsala_api: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: `contactID`,
  },
  crezu_api: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: `contactID`,
  },
  leadgid_api: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: `contactID`,
  },
  pdl_api: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: `contactID`,
  },
  densure: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: `contactID`,
  },
  densure1: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: `contactID`,
  },
  doaffapi: {
    click_id: 'clickId',
    web_id: 'web_id',
    addons: `contactID`,
  },
  xpartners: {
    click_id: 'clickid',
    web_id: 'cpa_wm_id',
    addons: '',
  },
  instagram: {
    click_id: 'utm_campaign',
    web_id: '',
    addons: '',
  },
  youtube: {
    click_id: 'utm_campaign',
    web_id: '',
    addons: '',
  },
  tiktok: {
    click_id: 'utm_campaign',
    web_id: '',
    addons: '',
  },
  yandex: {
    click_id: 'utm_campaign',
    web_id: '',
    addons: '',
  },
  google: {
    click_id: 'utm_campaign',
    web_id: '',
    addons: 'gclid',
  },
  sms: {
    click_id: 'utm_campaign',
    web_id: 'utm_medium',
    addons: '',
  },
  mircreditov: {
    click_id: 'clickId',
    web_id: 'utm_campaign',
    addons: 'utm_medium',
  },
  finstorm: {
    click_id: 'aff_sub',
    web_id: 'web_id',
    addons: '',
  },
  nolimit: {
    click_id: 'aff_sub',
    web_id: 'aff_id',
    addons: '',
  },
  moneypanda: {
    click_id: 'transaction_id',
    web_id: 'web_id',
    addons: '',
  },
  moneypanda_api: {
    click_id: 'clickID',
    web_id: 'web_id',
    addons: `contactID`,
  },
  workle: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: '',
  },
  leadssu_api: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: '',
  },
  cpa_affiliate: {
    click_id: 'utm_campaign',
    web_id: 'utm_medium',
    addons: '',
  },
  affiliate_cpa: {
    click_id: 'utm_campaign',
    web_id: '',
    addons: 'gclid',
  },
  traffic_lead: {
    click_id: 'utm_campaign',
    web_id: 'utm_medium',
    addons: '',
  },
  email: {
    click_id: 'utm_campaign',
    web_id: 'utm_medium',
    addons: '',
  },
  lead_traffic: {
    click_id: 'utm_campaign',
    web_id: '',
    addons: 'gclid',
  },
  c2m_api: {
    click_id: 'click_id',
    web_id: 'web_id',
    addons: `contactID`,
  },
};
